import { useTranslation } from 'react-i18next';

import { localeMeta, locales, type Locale, usePreferences } from '@rootsight/shared';

import { Select } from '../Select/Select';

/**
 * LanguageSwitcher changes the active locale and persists the choice. Both
 * SPAs mount it, so an operator who switches language on the login page keeps
 * it inside the console. Each language is named in itself ("עברית"), so an
 * operator who cannot read the current one can still find theirs.
 */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation('common');
  const setLocale = usePreferences((s) => s.setLocale);
  const current = (i18n.resolvedLanguage ?? 'en') as Locale;

  const change = async (next: string) => {
    setLocale(next as Locale);
    await i18n.changeLanguage(next);
  };

  return (
    <Select
      label={t('language.label')}
      showLabel={false}
      value={current}
      onChange={(next) => void change(next)}
      options={locales.map((code) => ({ id: code, label: localeMeta[code].nativeName }))}
    />
  );
}
